// Tiny, safe-enough markdown renderer for AI responses (headings, bold, bullets).
export function renderMarkdown(md) {
  if (!md) return "";
  const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const lines = md.split("\n");
  let html = "";
  let inList = false;
  const inline = (t) =>
    esc(t)
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/\*(.+?)\*/g, "<em>$1</em>")
      .replace(/`(.+?)`/g, '<code class="bg-slate-100 px-1 rounded text-xs">$1</code>');

  for (let raw of lines) {
    const line = raw.trim();
    if (!line) {
      if (inList) { html += "</ul>"; inList = false; }
      continue;
    }
    if (/^#{1,6}\s/.test(line)) {
      if (inList) { html += "</ul>"; inList = false; }
      const level = line.match(/^#+/)[0].length;
      const tag = level <= 2 ? "h2" : "h3";
      html += `<${tag}>${inline(line.replace(/^#+\s/, ""))}</${tag}>`;
    } else if (/^[-*]\s/.test(line)) {
      if (!inList) { html += '<ul class="list-disc pl-5 space-y-1">'; inList = true; }
      html += `<li>${inline(line.replace(/^[-*]\s/, ""))}</li>`;
    } else {
      if (inList) { html += "</ul>"; inList = false; }
      html += `<p class="my-1.5">${inline(line)}</p>`;
    }
  }
  if (inList) html += "</ul>";
  return html;
}
